module.exports = new __parcel__URL__("battleroyale_game_bg.227679ac.png").toString();